import { ca } from '@cian/analytics';

import { INewbuildingInfo } from '../../../../api/newbuildings';
import { IResultsState, IUserGADataLayerData, TUser } from '../../../../common/state/app_state';
import { IJsonQuery, IJsonQueryDeveloper, IJsonQueryGeo, IJsonQueryNewbuilding } from '../../../../json_query';
import { getNewbuildingExtra } from './getNewbuildingExtra';
import { getNewbuildingProduct } from './getNewbuildingProduct';
import { getOfferParentId } from '../../../../utils/trackings';

export const getDeveloperContactsLabel = (newbuildingInfo: INewbuildingInfo | null): string => {
  let moId = '';
  let oblId = '';
  let cityId = '';
  let newbuildingId = '';

  if (newbuildingInfo) {
    moId = String(newbuildingInfo.trackingData.moId);
    oblId = String(newbuildingInfo.trackingData.oblId);
    cityId = String(newbuildingInfo.trackingData.cityId);
    newbuildingId = String(newbuildingInfo.id);
  }

  return (
    `/sale/jk/mo_id=${moId}/obl_id=${oblId}/city_id=${cityId}` +
    `/object_type=2/ga_obj_type=0/spec=none/${newbuildingId}/from_developer=1/nv=1/`
  );
};

/* istanbul ignore next */
export const trackPhoneButtonClickedFromDeveloperContacts = (
  newbuildingInfo: INewbuildingInfo | null,
  geo: IJsonQueryGeo | undefined,
  userGADataLayerData: IUserGADataLayerData,
  jsonQuery: IJsonQuery,
  user: TUser,
  results: IResultsState,
  phone: string,
) => {
  let name = '';

  if (newbuildingInfo) {
    name = newbuildingInfo.name;
  }

  let id = '';
  let builderId = '';

  if (geo) {
    const newobjectTags = geo.value.filter(geoItem => geoItem.type === 'newobject') as IJsonQueryNewbuilding[];
    id = (newobjectTags.length && String(newobjectTags[0].id)) || '';

    const builderTags = geo.value.filter(geoItem => geoItem.type === 'builder') as IJsonQueryDeveloper[];
    builderId = (builderTags.length && String(builderTags[0].id)) || '';
  }

  const { totalOffers, queryString, offers } = results;
  const firstOffer = offers[0];
  const nv = Boolean(firstOffer && firstOffer.newbuilding && firstOffer.newbuilding.showJkReliableFlag);
  const parentId = getOfferParentId(firstOffer, jsonQuery);
  const cplExtra = getNewbuildingExtra(newbuildingInfo, phone);

  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_jk_head_block',
    label: getDeveloperContactsLabel(newbuildingInfo),
    searchConditions: jsonQuery,
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      objectType: 'JK',
      dealType: 'other',
      region: jsonQuery && jsonQuery.region ? String(jsonQuery.region.value[0]) : '1',
      listingType: 'list',
      sortType: jsonQuery && jsonQuery.sort ? jsonQuery.sort.value : 'default',
      pageNumber: jsonQuery && jsonQuery.page ? Number(jsonQuery.page.value) : 1,
      offersQty: Number(totalOffers),
      queryString,
    },
    products: [
      getNewbuildingProduct({
        parentId,
        id,
        nv,
        name,
        builderId,
        isDealRequestSubstitutionPhone: Boolean(firstOffer && firstOffer.isDealRequestSubstitutionPhone),
        cplExtra,
      }),
    ],
    user: {
      abGroup: userGADataLayerData ? Number(userGADataLayerData.abGroup) : 0,
      type: user.isAuthenticated && user.userType ? user.userType : 'not_authorized',
      email: user.isAuthenticated && user.email ? user.email : undefined,
      userId: user.isAuthenticated && user.userId ? Number(user.userId) : undefined,
      cianUserId: user.isAuthenticated && user.id ? Number(user.id) : undefined,
    },
  });
};

export const trackDevelopersContactsPopupOpened = (newbuildingInfo: INewbuildingInfo | null) => {
  ca('event', {
    name: 'oldevent',
    action: 'open_contacts',
    category: 'Listing',
    label: getDeveloperContactsLabel(newbuildingInfo),
  });
};
